import React, { useState, useEffect, useRef } from 'react';
import { CONFIG_MAX_LEGEND_ITEMS } from '@/components/charting/chartingConfiguration.constants';
import DataTable from '@/util/DataTable';
import { getResultOffsets } from './utils';
import { Header, Pagination, RowsRenderer } from './components';

// TODO: infer any(s).
export type DashboardTableProps = {
  dataTable: DataTable;
  getChartOption: any;
  getColumnLabel: any;
  isDashboard?: boolean;
};
export const DashboardTable: React.FC<DashboardTableProps> = ({
  dataTable,
  getChartOption,
  getColumnLabel,
  isDashboard,
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [areAllRowsShown, setAreAllRowsShown] = useState(false);
  const [containerHeight, setContainerHeight] = useState(0);
  const tableContainerRef = useRef<HTMLDivElement>(null);
  const numberOfHeadings = dataTable.headings().length;
  const totalNumberOfRows = dataTable.rows().length;
  const maxItems = getChartOption(CONFIG_MAX_LEGEND_ITEMS);

  const handleNextPageClick = () => setCurrentPage((v) => v + 1);
  const handlePrevPageClick = () => setCurrentPage((v) => v - 1);

  useEffect(() => {
    setContainerHeight(tableContainerRef.current?.offsetHeight ?? 0);
  });

  const numberOfCellsPerPage = containerHeight
    ? ((containerHeight - 80) / 41) * numberOfHeadings
    : 600;
  const rowsPerPage = Math.round(numberOfCellsPerPage / numberOfHeadings);
  const maxNumberOfRows = Math.min(
    maxItems || totalNumberOfRows,
    totalNumberOfRows,
  );
  const numberOfPages = Math.ceil(maxNumberOfRows / rowsPerPage);

  const showPagination = isDashboard && !areAllRowsShown && numberOfPages > 1;

  return (
    <div className="h-100 position-relative" ref={tableContainerRef}>
      <div className="position-relative h-100 overflow-auto">
        <table className="widget-table">
          <Header dataTable={dataTable} getColumnLabel={getColumnLabel} />
          <tbody>
            {isDashboard && <tr className="first-row" />}
            <RowsRenderer
              rows={dataTable
                .rows()
                .slice(
                  ...(showPagination
                    ? getResultOffsets(currentPage, rowsPerPage)
                    : [0, maxNumberOfRows]),
                )}
              dataTable={dataTable}
              getChartOption={getChartOption}
            />
          </tbody>
        </table>
      </div>
      {showPagination && (
        <Pagination
          numberOfPages={numberOfPages}
          currentPage={currentPage}
          onNextPageClick={handleNextPageClick}
          onPrevPageClick={handlePrevPageClick}
          onShowAll={() => setAreAllRowsShown(true)}
        />
      )}
    </div>
  );
};
